import { render, staticRenderFns } from "./ResetContactDND.vue?vue&type=template&id=05691485&scoped=true&"
import script from "./ResetContactDND.vue?vue&type=script&lang=js&"
export * from "./ResetContactDND.vue?vue&type=script&lang=js&"
import style0 from "./ResetContactDND.vue?vue&type=style&index=0&id=05691485&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05691485",
  null
  
)

export default component.exports